// removed by extract-text-webpack-plugin
module.exports = {"base":"LandingBonus_base--2_7GI","items":"LandingBonus_items--2FCGb","itemsContainer":"LandingBonus_itemsContainer--y4CuM","item":"LandingBonus_item--xhYB6","itemHeader":"LandingBonus_itemHeader--1ayqQ","imageContainer":"LandingBonus_imageContainer--2uNim","gold":"LandingBonus_gold--239M9","vehicle":"LandingBonus_vehicle--3hL9M","reserve":"LandingBonus_reserve--i9gF5","itemMessage":"LandingBonus_itemMessage--1qdIf"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingBonus/LandingBonus.scss
// module id = 2248
// module chunks = 11